
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/[resourceSlug]",
      function () {
        return require("private-next-pages/resources/[resourceSlug].tsx");
      }
    ]);
  